<div class="wrapper-auth-pages">
  <div class="wrapper-auth-left">
    <div class="wrapper-login-page">
      <div class="login-page login">
        <div class="wrapper-logo-auth">
          <img src="../assets/icons/logo-horizontal-yellow.svg" alt="">
        </div>
        <div class="info-auth-login">
          <h1>{{'FORGOT_PASSWORD.need_help_logging_in' | translate}}?</h1>
          <h6>{{'FORGOT_PASSWORD.if_your_number_is_already_registered' | translate}},</h6>
          <h6>{{'FORGOT_PASSWORD.you_can_access_the_app_directly' | translate}}.</h6>
        </div>
        <form [formGroup]="forgotForm" (ngSubmit)="onSubmitLoginForm()" novalidate class="wrapper-content-auth">
          <div class="wrapper-input" [ngClass]="{'error': forgotForm.controls['phone_number'] | formControlErrorMessages: 'Enter valid phone number.': formTriedToSubmit}">
            <span class="label-input">{{'NEW_TEXT.phone_number' | translate}}</span>
            <div class="wrapper-phone-number open" [ngClass]="{'open': isAreaCodeOpen}">
              <div #areaCodeBtn class="wrapper-flags" (click)="isAreaCodeOpen = !isAreaCodeOpen">
                <img class="icon-flag" [src]="'../../../../assets/icons/flags/' + selectedArea.code.toLowerCase() + '.png'" alt="">
                <img class="icon-arrow-flags" src="../../../assets/icons/icon-arrow-left.svg" alt="">
              </div>
              <div class="wrapper-number-country">
                <span>{{selectedArea.phone_code}}</span>
              </div>
              <input type="text" formControlName="phone_number">
              <div class="content-dropdown-phone-number" *ngIf="isAreaCodeOpen">
                <div class="item-dropdown-phone-number" *ngFor="let country of Countries" (click)="onSelectCodeArea(country)">
                  <img [src]="'../../../../assets/icons/flags/' + country.code.toLowerCase() + '.png'" alt="">
                  <span>{{country.name}} ({{country.phone_code}})</span>
                </div>
              </div>
            </div>
            <div *ngIf="forgotForm.controls['phone_number'] | formControlErrorMessages: 'Enter valid phone number.' : formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{forgotForm.controls['phone_number'] | formControlErrorMessages: 'Enter valid phone number.': formTriedToSubmit}}</span>
            </div>
          </div>
          <button class="custom-btn custom-btn--primary">
            <span *ngIf="!isSpinnerActive">{{'FORGOT_PASSWORD.send_my_verification_number' | translate}}</span>
            <tl-spinner *ngIf="isSpinnerActive"></tl-spinner>
          </button>
        </form>
      </div>
    </div>
  </div>
  <tl-onboarding-swipe class="wrapper-auth-right"></tl-onboarding-swipe>
</div>
